<div #contentDiv style="overflow: scroll; border: 1px solid black;"
  (scroll)="onScroll(contentDiv.scrollLeft, contentDiv.scrollTop)">

	<table style="table-layout: fixed;
		margin: 0px;
		border-top: 1px solid black;
		border-bottom: 1px solid black;
		border-left: 1px solid black;">

    @for (line of lines; track line) {
      <tr #row>
        <td class="diff-line-number">{{line.lineNumber}}</td>
        @if (!!line.text) {
          <td class="diff-line-text" [ngClass]="line.textStyle">{{line.text}}</td>
        }
        @if (!line.text) {
          <td class="diff-line-text" [ngClass]="line.textStyle">&nbsp;</td>
        }
      </tr>
    }

  </table>

  <!-- This empty DIV is needed to ensure that the contents of the diff file can always be scrolled all the way
  to the top of the outer DIV.  This is needed to make the "previous diff" and "next diff" features
  work properly.  The height of the nested empty DIV is the same height as the outer DIV, ensuring that the contents
  of the outer DIV can always be scrolled to the bottom of the diff file -->
  <div #emptyDiv>&nbsp;</div>

</div>